import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0;
`;

export const SignatureContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  canvas {
    border-radius: 4px;
    border: 3px dotted #ddd;
    background-color: #ffffff;
  }
`;

export const SignatureLabelsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 8px 15px 0px 15px;
  pointer-events: none;
  & label,
  a {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently*/
  }
`;
export const SignatureLabel = styled.div`
  font-size: 1rem;
  text-transform: uppercase;
  line-height: 0.8;
`;

export const SignatureClear = styled.a`
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  color: red;
  line-height: 0.8;
  cursor: pointer;
  pointer-events: all;
`;
